import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledSearchResultsPageMainContainer = styled.div`
  ${({ }) => `
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    `}
`;

export const StyledSearchFiltersContainer = styled.div`
  ${({ theme }) => `
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 4px rgba(187, 187, 187, 0.25);
      padding: 0 16px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 1;
      .search-filter_wrapper {
          width: 100%;
          max-width: calc( ${Breakpoints.b2560}px - ${theme.size.grid004});
      }
      @media screen and (min-width: ${Breakpoints.b560}px) {
          padding: 0 ${theme.size.grid002};
      }
  `}
`;

export const StyledFiltersAppliedContainer: any = styled.div`
  width: 83.5%;
  height: 100%;
  padding-top: 10px
`;

export const StyledResultsSectionContainer = styled.div`
  width: 100%;
  max-width: ${Breakpoints.b2560}px;
`;

export const StyledResultPaginationContainer = styled.div``;

export const StyledSearchAppliedFilterContainer = styled.div`
${({ }) => `
     width: 100%;
     padding: 0 16px;
     display: none;
     @media screen and (min-width: ${Breakpoints.b960}px) {
        display: block;
        padding: 0;
      }
      position: relative;
      z-index: 0;
`}`;

